import * as React from 'react';
import './sidebar.scss';
declare const $: any;

export interface SidebarInputProperties {
    icon?: string;
    title: string;
    link?: string;
    badge?: string;
}

export class SidebarItemComponent extends React.Component <SidebarInputProperties> {
    componentDidMount() {
        // tslint:disable-next-line
        $('[data-toggle="tooltip"]').tooltip();
        // * @TODO -> ezt miért futtatjuk le minden egyes menüpontnál? Miért nincs inkább a sidebar.tsx-ben?

    }

    render() {
        return (
            <li className={(window.location.pathname === `/${this.props.link}`) ? 'active' : ''}>
                {this.props.link && <a href={`/${this.props.link}`}>
                    {this.props.icon && <i className={`glyph-icon fa fa-fw ${this.props.icon}`}/>}
                    <span>{this.props.title}</span>
                    {this.props.badge && <span className="bs-label badge-primary">{this.props.badge}</span>}
                </a>}

                {!this.props.link && <a href="#" title="">
                    <i className={`glyph-icon fa fa-fw ${this.props.icon}`}/>
                    <span>
                        {this.props.title}
                        <i className="fa fa-caret-down ml-2"/>
                    </span>
                    {this.props.badge && <span className="bs-label badge-primary">{this.props.badge}</span>}
                    
                </a>}

                {this.props.children &&
                <div className="sidebar-submenu">
                    <ul>
                        {this.props.children}
                    </ul>
                </div>
                }
            </li>
        );
    }
}

export class SidebarItemGroupComponent extends React.Component <SidebarInputProperties> {
    render() {
        return (
            <ul className="sidebar-group">
                <li className="sidebar-header">
                    <span>{this.props.title}</span>
                </li>
                {this.props.children}
            </ul>
        );
    }
}

export class SidebarHeaderComponent extends React.Component <SidebarInputProperties> {
    render() {
        return (
            <li className="header"><span>{this.props.title}</span></li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/sidebar/sidebar-item.component.tsx